import { createBuilderModule } from '../../builder';
import { SectionName } from '../../observability/tracking/events';
import { withTracking } from '../../observability';
import { TwoColumnFeaturesSection } from './TwoColumnFeaturesSection';

export default createBuilderModule(
  withTracking(TwoColumnFeaturesSection, {
    sectionName: SectionName.TwoColumnFeaturesSection,
  }),
  {
    name: 'TwoColumnFeaturesSection',
    image:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTk-_jUvFon5YHpgdK0sN2wBuLdQLjyEwsTZg&usqp=CAU',
    inputs: [
      {
        name: 'heading',
        type: 'string',
        required: true,
      },
      {
        name: 'description',
        type: 'richText',
      },
      {
        name: 'features',
        type: 'list',
        subFields: [
          { name: 'heading', type: 'string', required: true },
          { name: 'description', type: 'richText' },
          { name: 'href', type: 'string' },
          { name: 'linkText', type: 'string' },
        ],
        required: true,
      },
    ],
  },
);
